import { render, staticRenderFns } from "./PushMessageCreation.vue?vue&type=template&id=5f10861b&scoped=true"
import script from "./PushMessageCreation.vue?vue&type=script&lang=js"
export * from "./PushMessageCreation.vue?vue&type=script&lang=js"
import style0 from "./PushMessageCreation.vue?vue&type=style&index=0&id=5f10861b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f10861b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f10861b')) {
      api.createRecord('5f10861b', component.options)
    } else {
      api.reload('5f10861b', component.options)
    }
    module.hot.accept("./PushMessageCreation.vue?vue&type=template&id=5f10861b&scoped=true", function () {
      api.rerender('5f10861b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/messagePush/components/PushMessageCreation.vue"
export default component.exports